// Module
var code = "<task-comment-container :loading=\"this.loading\" :taskId=\"this.task.id\" :users=\"this.stuff\" :comments=\"this.comments\" :deleteComment=\"deleteComment\" :showDeleted=\"showDeleted\" :showDeletedChanged=\"showDeletedChanged\"> </task-comment-container> ";
// Exports
module.exports = code;